





















































































































import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import VueGallery from 'vue-gallery';
import commonService from '@/services/common-services';
@Component({
    components: {
        'gallery': VueGallery
    }
})
export default class ListProduct extends Vue {
    private eventEmit = {
        eventAddRow: 'eventAddRow',
        eventRemoveRow: 'eventRemoveRow'
    };

    @Prop({default: null})
    private listProducts: any;

    @Prop()
    private checkValid: any;

    private limit = 10000;
    private currentItem: any = null;
    private imageData: any = null;
    private uploadValue = 0;
    private hideImage = false;

    get currentTime() {
        return Date.now();
    }

    get isMobileScreen() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    private async addRow() {
        if (this.listProducts.length >= this.limit) {
            return false;
        }
        this.$emit(this.eventEmit.eventAddRow, null);
    }

    private async removeRow(index: number) {
        this.$emit(this.eventEmit.eventRemoveRow, index);
    }

    private chooseImage(item) {
        this.currentItem = item;
        this.currentItem.image_origin = '';
        this.$refs.fileInput[0].click();
    }

    private previewImage(event) {
        this.uploadValue = 0;
        this.imageData = event.target.files[0];
        this.$refs.fileInput[0].value = null;
        this.onUpload()
    }

    private async onUpload() {
        if (!this.imageData) {
            return;
        }
        this.uploadValue = 10;
        try {
            const res: any = await commonService.uploadR2File(this.imageData);
            if (res && res.data && res.data.status === 200 && res.data.data && res.data.data.url) {
                this.uploadValue = 100;
                this.currentItem.image_origin = res.data.data.url;
                this.hideImage = true;
                this.$nextTick(() => this.hideImage = false);
            } else {
                const msg = (res && res.data && (res.data.message || res.data.reason)) || 'Lỗi không xác định';
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Upload ảnh thất bại: ' + msg,
                });
            }
        } catch (error) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Không thể upload ảnh!',
            });
        }
    }

    private getImages(index) {
        return this.listProducts[index].image_origin;
    }
}
